import * as React from "react";
const SvgYahoo = (props) => /* @__PURE__ */ React.createElement("svg", { baseProfile: "basic", id: "Layer_1", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", x: "0px", y: "0px", viewBox: "0 0 48 48", xmlSpace: "preserve", ...props }, /* @__PURE__ */ React.createElement("polygon", { style: {
  fill: "#5E35B1"
}, points: "4.209,14.881 11.632,14.881 16.189,26.715 20.966,14.881 28.315,14.881 17.07,42 9.501,42  12.587,34.96 " }), /* @__PURE__ */ React.createElement("circle", { style: {
  fill: "#5E35B1"
}, cx: 29.276, cy: 30.522, r: 4.697 }), /* @__PURE__ */ React.createElement("polygon", { style: {
  fill: "#5E35B1"
}, points: "34.693,6 27.213,24.042 35.444,24.042 42.925,6 " }));
export default SvgYahoo;
